import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.5 16.999V19.5H7V21H3v-4.001h1.5ZM11 19.5V21H9v-1.5h2Zm4 0V21h-2v-1.5h2Zm6-2.501V21h-4v-1.5h2.5v-2.501H21Zm-16.5-4v2H3v-2h1.5Zm16.5 0v2h-1.5v-2H21Zm-16.5-4v2H3v-2h1.5Zm16.5 0v2h-1.5v-2H21ZM7 3v1.5H4.5v2.499H3V3h4Zm14 0v3.999h-1.5V4.5H17V3h4ZM11 3v1.5H9V3h2Zm4 0v1.5h-2V3h2Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }